// @flow
import { APIVersion } from './apiVersion';

export default APIVersion.v6;



// WEBPACK FOOTER //
// ../utilities/apiDefault.js